import { TableCell, TableRow, Typography } from "@material-ui/core";

type Props = {
  title: string;
};

export function YearHeader(props: Props) {
  return (
    <TableRow>
      <TableCell
        style={{ border: "none", padding: "8px 8px 0px 8px", userSelect: "none" }}
      >
        <Typography variant="caption" color="primary">
          {props.title}
        </Typography>
      </TableCell>
    </TableRow>
  );
}
